import { useContext } from "react";
import { AuthContext } from "../../context/context";
import PropTypes from "prop-types";

const LetterItem = ({ letterItem }) => {
  const { userData } = useContext(AuthContext);

  return (
    <div className="relative w-full h-full flex flex-col justify-between px-6 py-8 bg-white rounded-md shadow-xs card-base-border font-headline">
      <div className="flex flex-col gap-8">
        <p className="text-right text-sm italic font-headline">
          {new Date(letterItem.createdAt).toLocaleDateString()}
        </p>
        <div className="flex flex-col gap-2">
          <p className="text-base font-headline font-semibold">
            {letterItem.title_letter}
          </p>

          <div className="note-description-container">
            <p className="font-headline whitespace-pre-wrap">
              {letterItem.letter}
            </p>
          </div>
        </div>
        <div className="mt-5 text-right  italic font-headline">
          Love,
          <br />
          <span className="text-base font-headline">
            {userData?.first_name || "Future Me"}
          </span>
        </div>
      </div>
    </div>
  );
};

LetterItem.propTypes = {
  letterItem: PropTypes.object.isRequired,
};

export default LetterItem;
